import React from 'react';
import { BRAND_LIBRARY_DARK_TEXT_COLOR, BRAND_LIBRARY_LIGHT_TEXT_COLOR } from 'common/constants/brandLibrary';

import CustomButton from '../CustomButton';

export default function CustomButtonLight(props) {
    return <CustomButton {...props} />;
}

CustomButtonLight.splash = {
    ...CustomButton.splash,
    defaultProps: {
        ...CustomButton.splash.defaultProps,
        styles: {
            ...CustomButton.splash.defaultProps.styles,
            backgroundColor: BRAND_LIBRARY_LIGHT_TEXT_COLOR,
            backgroundColorHover: BRAND_LIBRARY_DARK_TEXT_COLOR,
            fontColor: BRAND_LIBRARY_DARK_TEXT_COLOR,
            fontColorHover: BRAND_LIBRARY_LIGHT_TEXT_COLOR,
        },
        meta: {
            ...CustomButton.splash.defaultProps.meta,
            content: 'Click Here',
        },
    },
};
